import axios from 'src/store/vue-axios/axios.js'

export default class Misc {
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API ENDPOINTS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // LINKS -> /misc/links*
  static miscLinksUrl = () => '/links'
  static miscLinksByIdUrl = (id) => `/links/${id}`
  static miscLinksReorderUrl = () => '/links/reorder'

  // USERS -> /misc/users*
  static miscUsersFujitsuSsoByIdUrl = (userId) => `/misc/users/${userId}/misc/fujitsu-sso`

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // API IMPLEMENTATIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // LINKS -> /misc/links*
  static async postMiscLinks (payload) {
    return axios.post(this.miscLinksUrl(), payload)
  }

  static async deleteMiscLinksById (id) {
    return axios.delete(this.miscLinksByIdUrl(id))
  }

  static async putMiscLinksById (id, payload) {
    return axios.put(this.miscLinksByIdUrl(id), payload)
  }

  static async putMiscLinksReorder (payload) {
    return axios.put(this.miscLinksReorderUrl(), payload)
  }

  // USERS -> /misc/users*
  static async getMiscUsersFujitsuSsoById (userId) {
    return axios.get(this.miscUsersFujitsuSsoByIdUrl(userId))
  }

  static async headDownloadableFile (url) {
    return axios.head(url)
  }
}
